export const PASSWORD_VIEW = '********';
